import React from 'react';
import { Center, Heading, Image, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import chargerImg from '../../../assets/images/evse_charger_success.svg';
import { ArcButton } from '../../../common/components/ArcButton';
import { SlidingAnimationPageBase } from '../../../common/components/SlidingAnimationPageBase';

/* istanbul ignore next -- @preserve */
export function SetupSuccess() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <SlidingAnimationPageBase title={t('Common.device setup')}>
      <Center flexDirection="column" px={3} textAlign="center">
        <Image data-testid="ev-charger-image" src={chargerImg} alt="Charging Station Setup Successful" ml={7} my={4} />

        <Heading mt={2}>{t('Set Up Hardware.setup successful')}</Heading>
        <Text data-testid="ev-setup-complete-text" mt={1}>
          {t('EVSE.charger added text')}
        </Text>

        <ArcButton
          data-testid="ev-charger-continue"
          onClick={() => navigate('../device-status')}
          mt={8}
          w={'80%'}
          arcColor="#3DCD57"
        >
          {t('Common.continue')}
        </ArcButton>
      </Center>
    </SlidingAnimationPageBase>
  );
}
